// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file player/v1/player.proto (package player.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file player/v1/player.proto.
 */
export const file_player_v1_player: GenFile = /*@__PURE__*/
  fileDesc("ChZwbGF5ZXIvdjEvcGxheWVyLnByb3RvEglwbGF5ZXIudjEiJAoPUmVnaXN0ZXJSZXF1ZXN0EhEKCWRldmljZV9pZBgBIAEoCSJLChBSZWdpc3RlclJlc3BvbnNlEg0KBXRva2VuGAEgASgJEigKBnBsYXllchgCIAEoCzIYLnBsYXllci52MS5QbGF5ZXJQcm9maWxlIiEKDExvZ2luUmVxdWVzdBIRCglkZXZpY2VfaWQYASABKAkiSAoNTG9naW5SZXNwb25zZRINCgV0b2tlbhgBIAEoCRIoCgZwbGF5ZXIYAiABKAsyGC5wbGF5ZXIudjEuUGxheWVyUHJvZmlsZSJlChVVcGRhdGVMb2NhdGlvblJlcXVlc3QSEQoJcGxheWVyX2lkGAEgASgJEhAKCGxhdGl0dWRlGAIgASgBEhEKCWxvbmdpdHVkZRgDIAEoARIUCgx0aW1lc3RhbXBfbXMYBCABKAMiQQoWVXBkYXRlTG9jYXRpb25SZXNwb25zZRIRCglzcGVlZF9rbWgYASABKAESFAoMZmxhZ2dlZF9mYXN0GAIgASgIIiUKEEdldFBsYXllclJlcXVlc3QSEQoJcGxheWVyX2lkGAEgASgJIvsHCg1QbGF5ZXJQcm9maWxlEhEKCXBsYXllcl9pZBgBIAEoCRIPCgdmYWN0aW9uGAIgASgJEhIKCmRpcnR5X2Nhc2gYAyABKAMSFwoPY2xlYW5faW5mbHVlbmNlGAQgASgDEgwKBGhlYXQYBSABKAUSDgoGaGVhbHRoGAYgASgFEhUKCG5pY2tuYW1lGAcgASgJSACIAQESEgoFZW1haWwYCCABKAlIAYgBARIKCgJ4cBgJIAEoAxINCgVsZXZlbBgKIAEoBRISCgpjbGVhbl9jYXNoGAsgASgDEhIKCm1heF9oZWFsdGgYDCABKAUSDgoGc3RhdHVzGA0gASgJEhoKDXN0YXR1c19yZWFzb24YDiABKAlIAogBARIgChNzdGF0dXNfZGF0ZV91bml4X21zGA8gASgDSAOIAQESIgoVc2FmZWhvdXNlX2J1aWxkaW5nX2lkGBAgASgJSASIAQESHAoUcmVnaXN0cmF0aW9uX3VuaXhfbXMYESABKAMSHwoSbGFzdF9sb2dpbl91bml4X21zGBIgASgDSAWIAQESHgoRbGFzdF9zZWVuX3VuaXhfbXMYEyABKANIBogBARIWCglkZXZpY2VfaWQYFCABKAlIB4gBARIQCghsYXN0X2xhdBgVIAEoARIQCghsYXN0X2xuZxgWIAEoARIUCgxsYXN0X3MyX2NlbGwYFyABKAkSFQoNaGVhdF9jYXBhY2l0eRgYIAEoBRIOCgZhdHRhY2sYGSABKAUSEgoKYmFzZV9hcm1vchgaIAEoBRISCgpyYW5rX3BoYXNlGBsgASgJEh0KFWxheV9sb3dfdW50aWxfdW5peF9tcxgcIAEoAxIWCg5mYWN0aW9uX2Nob3NlbhgdIAEoCBIWCg5zYWZlaG91c2VfY2FzaBgeIAEoAxIRCglmYW1pbHlfaWQYHyABKAkSEwoLZmFtaWx5X25hbWUYICABKAkSEgoKZmFtaWx5X3RhZxghIAEoCRIXCg9mYW1pbHlfY3Jlc3RfaWQYIiABKAUSGQoRZmFtaWx5X2NyZXN0X3RpbnQYIyABKAkSGQoRY29zbWV0aWNfc2tpbl9za3UYJCABKAkSFQoNY29tYmF0X3N0YW5jZRglIAEoCRIUCgxhZ2VfdmVyaWZpZWQYJiABKAhCCwoJX25pY2tuYW1lQggKBl9lbWFpbEIQCg5fc3RhdHVzX3JlYXNvbkIWChRfc3RhdHVzX2RhdGVfdW5peF9tc0IYChZfc2FmZWhvdXNlX2J1aWxkaW5nX2lkQhUKE19sYXN0X2xvZ2luX3VuaXhfbXNCFAoSX2xhc3Rfc2Vlbl91bml4X21zQgwKCl9kZXZpY2VfaWQiOQoSR29vZ2xlTG9naW5SZXF1ZXN0EhAKCGlkX3Rva2VuGAEgASgJEhEKCWRldmljZV9pZBgCIAEoCSI/ChRGYWNlYm9va0xvZ2luUmVxdWVzdBIUCgxhY2Nlc3NfdG9rZW4YASABKAkSEQoJZGV2aWNlX2lkGAIgASgJImAKFEVtYWlsUmVnaXN0ZXJSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJEhQKDGRpc3BsYXlfbmFtZRgDIAEoCRIRCglkZXZpY2VfaWQYBCABKAkiNAoRRW1haWxMb2dpblJlcXVlc3QSDQoFZW1haWwYASABKAkSEAoIcGFzc3dvcmQYAiABKAkiLAoTUmVmcmVzaFRva2VuUmVxdWVzdBIVCg1yZWZyZXNoX3Rva2VuGAEgASgJIiwKE1BsYXllckxvZ291dFJlcXVlc3QSFQoNcmVmcmVzaF90b2tlbhgBIAEoCSIWChRQbGF5ZXJMb2dvdXRSZXNwb25zZSJ8CgxBdXRoUmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEhUKDXJlZnJlc2hfdG9rZW4YAiABKAkSKAoGcGxheWVyGAMgASgLMhgucGxheWVyLnYxLlBsYXllclByb2ZpbGUSFQoNaXNfbmV3X3BsYXllchgEIAEoCCKXAQoTTGlua1Byb3ZpZGVyUmVxdWVzdBIZCg9nb29nbGVfaWRfdG9rZW4YASABKAlIABIfChVmYWNlYm9va19hY2Nlc3NfdG9rZW4YAiABKAlIABI2ChBlbWFpbF9jcmVkZW50aWFsGAMgASgLMhoucGxheWVyLnYxLkVtYWlsQ3JlZGVudGlhbEgAQgwKCmNyZWRlbnRpYWwiMgoPRW1haWxDcmVkZW50aWFsEg0KBWVtYWlsGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJIigKFExpbmtQcm92aWRlclJlc3BvbnNlEhAKCHByb3ZpZGVyGAEgASgJIikKFVVubGlua1Byb3ZpZGVyUmVxdWVzdBIQCghwcm92aWRlchgBIAEoCSIYChZVbmxpbmtQcm92aWRlclJlc3BvbnNlIjgKEFNlbmRNb25leVJlcXVlc3QSFAoMdG9fcGxheWVyX2lkGAEgASgJEg4KBmFtb3VudBgCIAEoAyJ/ChFTZW5kTW9uZXlSZXNwb25zZRIWCg50cmFuc2FjdGlvbl9pZBgBIAEoCRIZChFzZW5kZXJfZGlydHlfY2FzaBgCIAEoAxIbChNyZWNlaXZlcl9kaXJ0eV9jYXNoGAMgASgDEhoKEnRyYW5zZmVycmVkX2Ftb3VudBgEIAEoAyIkChFTZXRGYWN0aW9uUmVxdWVzdBIPCgdmYWN0aW9uGAEgASgJIj4KElNldEZhY3Rpb25SZXNwb25zZRIoCgZwbGF5ZXIYASABKAsyGC5wbGF5ZXIudjEuUGxheWVyUHJvZmlsZSIiChBTZXRTdGFuY2VSZXF1ZXN0Eg4KBnN0YW5jZRgBIAEoCSI9ChFTZXRTdGFuY2VSZXNwb25zZRIoCgZwbGF5ZXIYASABKAsyGC5wbGF5ZXIudjEuUGxheWVyUHJvZmlsZSKqAQoMQ29uc2VudEV2ZW50Eg0KBXNjb3BlGAEgASgJEg8KB2dyYW50ZWQYAiABKAgSFgoOcG9saWN5X3ZlcnNpb24YAyABKAUSDgoGc291cmNlGAQgASgJEhEKCXVpX2xvY2FsZRgFIAEoCRITCgthcHBfdmVyc2lvbhgGIAEoCRIQCghwbGF0Zm9ybRgHIAEoCRIYChBvY2N1cnJlZF91bml4X21zGAggASgDIj8KFFJlY29yZENvbnNlbnRSZXF1ZXN0EicKBmV2ZW50cxgBIAMoCzIXLnBsYXllci52MS5Db25zZW50RXZlbnQiKQoVUmVjb3JkQ29uc2VudFJlc3BvbnNlEhAKCHJlY29yZGVkGAEgASgFIhQKEkdldENvbnNlbnRzUmVxdWVzdCJgCgxDb25zZW50U3RhdGUSDQoFc2NvcGUYASABKAkSDwoHZ3JhbnRlZBgCIAEoCBIWCg5wb2xpY3lfdmVyc2lvbhgDIAEoBRIYChBvY2N1cnJlZF91bml4X21zGAQgASgDIkAKE0dldENvbnNlbnRzUmVzcG9uc2USKQoIY29uc2VudHMYASADKAsyFy5wbGF5ZXIudjEuQ29uc2VudFN0YXRlIjAKGVNldEFnZVZlcmlmaWNhdGlvblJlcXVlc3QSEwoLYWdlX2JyYWNrZXQYASABKAkiRgoaU2V0QWdlVmVyaWZpY2F0aW9uUmVzcG9uc2USKAoGcGxheWVyGAEgASgLMhgucGxheWVyLnYxLlBsYXllclByb2ZpbGUiSgoMUmV0YWluZWRJdGVtEhQKDGNhdGVnb3J5X2tleRgBIAEoCRIRCgliYXNpc19rZXkYAiABKAkSEQoJdW50aWxfa2V5GAMgASgJImgKHVJlcXVlc3RBY2NvdW50RGVsZXRpb25SZXF1ZXN0EhAKCHBhc3N3b3JkGAEgASgJEhYKDnByb3ZpZGVyX3Rva2VuGAIgASgJEh0KFW5pY2tuYW1lX2NvbmZpcm1hdGlvbhgDIAEoCSKMAQoeUmVxdWVzdEFjY291bnREZWxldGlvblJlc3BvbnNlEhkKEXJlcXVlc3RlZF91bml4X21zGAEgASgDEiQKHHNjaGVkdWxlZF9jb21wbGV0aW9uX3VuaXhfbXMYAiABKAMSKQoIcmV0YWluZWQYAyADKAsyFy5wbGF5ZXIudjEuUmV0YWluZWRJdGVtIh4KHENhbmNlbEFjY291bnREZWxldGlvblJlcXVlc3QiSQodQ2FuY2VsQWNjb3VudERlbGV0aW9uUmVzcG9uc2USKAoGcGxheWVyGAEgASgLMhgucGxheWVyLnYxLlBsYXllclByb2ZpbGUiIQofR2V0QWNjb3VudERlbGV0aW9uU3RhdHVzUmVxdWVzdCKdAQogR2V0QWNjb3VudERlbGV0aW9uU3RhdHVzUmVzcG9uc2USDQoFc3RhdGUYASABKAkSGQoRcmVxdWVzdGVkX3VuaXhfbXMYAiABKAMSJAocc2NoZWR1bGVkX2NvbXBsZXRpb25fdW5peF9tcxgDIAEoAxIpCghyZXRhaW5lZBgEIAMoCzIXLnBsYXllci52MS5SZXRhaW5lZEl0ZW0iLQoYUmVxdWVzdERhdGFFeHBvcnRSZXF1ZXN0EhEKCXVpX2xvY2FsZRgBIAEoCSJwChlSZXF1ZXN0RGF0YUV4cG9ydFJlc3BvbnNlEg4KBmpvYl9pZBgBIAEoCRINCgVzdGF0ZRgCIAEoCRIZChFyZXF1ZXN0ZWRfdW5peF9tcxgDIAEoAxIZChFlc3RpbWF0ZWRfc2Vjb25kcxgEIAEoBSIWChRHZXREYXRhRXhwb3J0UmVxdWVzdCLJAQoVR2V0RGF0YUV4cG9ydFJlc3BvbnNlEg0KBXN0YXRlGAEgASgJEhkKEXJlcXVlc3RlZF91bml4X21zGAIgASgDEhkKEWNvbXBsZXRlZF91bml4X21zGAMgASgDEhQKDGRvd25sb2FkX3VybBgEIAEoCRIgChhkb3dubG9hZF9leHBpcmVzX3VuaXhfbXMYBSABKAMSEgoKc2l6ZV9ieXRlcxgGIAEoAxIfChdhdmFpbGFibGVfdW50aWxfdW5peF9tcxgHIAEoAzKDDwoNUGxheWVyU2VydmljZRJDCghSZWdpc3RlchIaLnBsYXllci52MS5SZWdpc3RlclJlcXVlc3QaGy5wbGF5ZXIudjEuUmVnaXN0ZXJSZXNwb25zZRI6CgVMb2dpbhIXLnBsYXllci52MS5Mb2dpblJlcXVlc3QaGC5wbGF5ZXIudjEuTG9naW5SZXNwb25zZRJVCg5VcGRhdGVMb2NhdGlvbhIgLnBsYXllci52MS5VcGRhdGVMb2NhdGlvblJlcXVlc3QaIS5wbGF5ZXIudjEuVXBkYXRlTG9jYXRpb25SZXNwb25zZRJCCglHZXRQbGF5ZXISGy5wbGF5ZXIudjEuR2V0UGxheWVyUmVxdWVzdBoYLnBsYXllci52MS5QbGF5ZXJQcm9maWxlEkkKD0xvZ2luV2l0aEdvb2dsZRIdLnBsYXllci52MS5Hb29nbGVMb2dpblJlcXVlc3QaFy5wbGF5ZXIudjEuQXV0aFJlc3BvbnNlEk0KEUxvZ2luV2l0aEZhY2Vib29rEh8ucGxheWVyLnYxLkZhY2Vib29rTG9naW5SZXF1ZXN0GhcucGxheWVyLnYxLkF1dGhSZXNwb25zZRJNChFSZWdpc3RlcldpdGhFbWFpbBIfLnBsYXllci52MS5FbWFpbFJlZ2lzdGVyUmVxdWVzdBoXLnBsYXllci52MS5BdXRoUmVzcG9uc2USRwoOTG9naW5XaXRoRW1haWwSHC5wbGF5ZXIudjEuRW1haWxMb2dpblJlcXVlc3QaFy5wbGF5ZXIudjEuQXV0aFJlc3BvbnNlEkcKDFJlZnJlc2hUb2tlbhIeLnBsYXllci52MS5SZWZyZXNoVG9rZW5SZXF1ZXN0GhcucGxheWVyLnYxLkF1dGhSZXNwb25zZRJPCgxQbGF5ZXJMb2dvdXQSHi5wbGF5ZXIudjEuUGxheWVyTG9nb3V0UmVxdWVzdBofLnBsYXllci52MS5QbGF5ZXJMb2dvdXRSZXNwb25zZRJPCgxMaW5rUHJvdmlkZXISHi5wbGF5ZXIudjEuTGlua1Byb3ZpZGVyUmVxdWVzdBofLnBsYXllci52MS5MaW5rUHJvdmlkZXJSZXNwb25zZRJVCg5VbmxpbmtQcm92aWRlchIgLnBsYXllci52MS5VbmxpbmtQcm92aWRlclJlcXVlc3QaIS5wbGF5ZXIudjEuVW5saW5rUHJvdmlkZXJSZXNwb25zZRJGCglTZW5kTW9uZXkSGy5wbGF5ZXIudjEuU2VuZE1vbmV5UmVxdWVzdBocLnBsYXllci52MS5TZW5kTW9uZXlSZXNwb25zZRJJCgpTZXRGYWN0aW9uEhwucGxheWVyLnYxLlNldEZhY3Rpb25SZXF1ZXN0Gh0ucGxheWVyLnYxLlNldEZhY3Rpb25SZXNwb25zZRJGCglTZXRTdGFuY2USGy5wbGF5ZXIudjEuU2V0U3RhbmNlUmVxdWVzdBocLnBsYXllci52MS5TZXRTdGFuY2VSZXNwb25zZRJSCg1SZWNvcmRDb25zZW50Eh8ucGxheWVyLnYxLlJlY29yZENvbnNlbnRSZXF1ZXN0GiAucGxheWVyLnYxLlJlY29yZENvbnNlbnRSZXNwb25zZRJMCgtHZXRDb25zZW50cxIdLnBsYXllci52MS5HZXRDb25zZW50c1JlcXVlc3QaHi5wbGF5ZXIudjEuR2V0Q29uc2VudHNSZXNwb25zZRJhChJTZXRBZ2VWZXJpZmljYXRpb24SJC5wbGF5ZXIudjEuU2V0QWdlVmVyaWZpY2F0aW9uUmVxdWVzdBolLnBsYXllci52MS5TZXRBZ2VWZXJpZmljYXRpb25SZXNwb25zZRJtChZSZXF1ZXN0QWNjb3VudERlbGV0aW9uEigucGxheWVyLnYxLlJlcXVlc3RBY2NvdW50RGVsZXRpb25SZXF1ZXN0GikucGxheWVyLnYxLlJlcXVlc3RBY2NvdW50RGVsZXRpb25SZXNwb25zZRJqChVDYW5jZWxBY2NvdW50RGVsZXRpb24SJy5wbGF5ZXIudjEuQ2FuY2VsQWNjb3VudERlbGV0aW9uUmVxdWVzdBooLnBsYXllci52MS5DYW5jZWxBY2NvdW50RGVsZXRpb25SZXNwb25zZRJzChhHZXRBY2NvdW50RGVsZXRpb25TdGF0dXMSKi5wbGF5ZXIudjEuR2V0QWNjb3VudERlbGV0aW9uU3RhdHVzUmVxdWVzdBorLnBsYXllci52MS5HZXRBY2NvdW50RGVsZXRpb25TdGF0dXNSZXNwb25zZRJeChFSZXF1ZXN0RGF0YUV4cG9ydBIjLnBsYXllci52MS5SZXF1ZXN0RGF0YUV4cG9ydFJlcXVlc3QaJC5wbGF5ZXIudjEuUmVxdWVzdERhdGFFeHBvcnRSZXNwb25zZRJSCg1HZXREYXRhRXhwb3J0Eh8ucGxheWVyLnYxLkdldERhdGFFeHBvcnRSZXF1ZXN0GiAucGxheWVyLnYxLkdldERhdGFFeHBvcnRSZXNwb25zZUJPWjNnaXRodWIuY29tL21hZmlhZ28vc2VydmVyL2dlbi9nby9wbGF5ZXIvdjE7cGxheWVydjGqAhdNYWZpYUdvLlByb3RvLlBsYXllci5WMWIGcHJvdG8z");

/**
 * @generated from message player.v1.RegisterRequest
 */
export type RegisterRequest = Message<"player.v1.RegisterRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message player.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 0);

/**
 * @generated from message player.v1.RegisterResponse
 */
export type RegisterResponse = Message<"player.v1.RegisterResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: player.v1.PlayerProfile player = 2;
   */
  player?: PlayerProfile | undefined;
};

/**
 * Describes the message player.v1.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 1);

/**
 * @generated from message player.v1.LoginRequest
 */
export type LoginRequest = Message<"player.v1.LoginRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message player.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 2);

/**
 * @generated from message player.v1.LoginResponse
 */
export type LoginResponse = Message<"player.v1.LoginResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: player.v1.PlayerProfile player = 2;
   */
  player?: PlayerProfile | undefined;
};

/**
 * Describes the message player.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 3);

/**
 * @generated from message player.v1.UpdateLocationRequest
 */
export type UpdateLocationRequest = Message<"player.v1.UpdateLocationRequest"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: double latitude = 2;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 3;
   */
  longitude: number;

  /**
   * @generated from field: int64 timestamp_ms = 4;
   */
  timestampMs: bigint;
};

/**
 * Describes the message player.v1.UpdateLocationRequest.
 * Use `create(UpdateLocationRequestSchema)` to create a new message.
 */
export const UpdateLocationRequestSchema: GenMessage<UpdateLocationRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 4);

/**
 * @generated from message player.v1.UpdateLocationResponse
 */
export type UpdateLocationResponse = Message<"player.v1.UpdateLocationResponse"> & {
  /**
   * @generated from field: double speed_kmh = 1;
   */
  speedKmh: number;

  /**
   * @generated from field: bool flagged_fast = 2;
   */
  flaggedFast: boolean;
};

/**
 * Describes the message player.v1.UpdateLocationResponse.
 * Use `create(UpdateLocationResponseSchema)` to create a new message.
 */
export const UpdateLocationResponseSchema: GenMessage<UpdateLocationResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 5);

/**
 * @generated from message player.v1.GetPlayerRequest
 */
export type GetPlayerRequest = Message<"player.v1.GetPlayerRequest"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;
};

/**
 * Describes the message player.v1.GetPlayerRequest.
 * Use `create(GetPlayerRequestSchema)` to create a new message.
 */
export const GetPlayerRequestSchema: GenMessage<GetPlayerRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 6);

/**
 * @generated from message player.v1.PlayerProfile
 */
export type PlayerProfile = Message<"player.v1.PlayerProfile"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: string faction = 2;
   */
  faction: string;

  /**
   * @generated from field: int64 dirty_cash = 3;
   */
  dirtyCash: bigint;

  /**
   * @generated from field: int64 clean_influence = 4;
   */
  cleanInfluence: bigint;

  /**
   * @generated from field: int32 heat = 5;
   */
  heat: number;

  /**
   * @generated from field: int32 health = 6;
   */
  health: number;

  /**
   * Profile / progression / lifecycle fields.
   *
   * @generated from field: optional string nickname = 7;
   */
  nickname?: string | undefined;

  /**
   * @generated from field: optional string email = 8;
   */
  email?: string | undefined;

  /**
   * @generated from field: int64 xp = 9;
   */
  xp: bigint;

  /**
   * @generated from field: int32 level = 10;
   */
  level: number;

  /**
   * @generated from field: int64 clean_cash = 11;
   */
  cleanCash: bigint;

  /**
   * @generated from field: int32 max_health = 12;
   */
  maxHealth: number;

  /**
   * @generated from field: string status = 13;
   */
  status: string;

  /**
   * @generated from field: optional string status_reason = 14;
   */
  statusReason?: string | undefined;

  /**
   * @generated from field: optional int64 status_date_unix_ms = 15;
   */
  statusDateUnixMs?: bigint | undefined;

  /**
   * @generated from field: optional string safehouse_building_id = 16;
   */
  safehouseBuildingId?: string | undefined;

  /**
   * @generated from field: int64 registration_unix_ms = 17;
   */
  registrationUnixMs: bigint;

  /**
   * @generated from field: optional int64 last_login_unix_ms = 18;
   */
  lastLoginUnixMs?: bigint | undefined;

  /**
   * @generated from field: optional int64 last_seen_unix_ms = 19;
   */
  lastSeenUnixMs?: bigint | undefined;

  /**
   * Device + last known location.
   *
   * @generated from field: optional string device_id = 20;
   */
  deviceId?: string | undefined;

  /**
   * @generated from field: double last_lat = 21;
   */
  lastLat: number;

  /**
   * @generated from field: double last_lng = 22;
   */
  lastLng: number;

  /**
   * @generated from field: string last_s2_cell = 23;
   */
  lastS2Cell: string;

  /**
   * Leveling-derived combat / heat stats. Owned by internal/leveling — every
   * crossed level overwrites these from level_configs.
   *
   * @generated from field: int32 heat_capacity = 24;
   */
  heatCapacity: number;

  /**
   * @generated from field: int32 attack = 25;
   */
  attack: number;

  /**
   * @generated from field: int32 base_armor = 26;
   */
  baseArmor: number;

  /**
   * @generated from field: string rank_phase = 27;
   */
  rankPhase: string;

  /**
   * Lay-low window after a police bust, unix millis; 0 when not laying low.
   * Lets a relaunched client restore the busted screen + countdown (the
   * realtime `busted` push is only seen by clients online at bust time).
   * Self-profile only — the public projection never sets it.
   *
   * @generated from field: int64 lay_low_until_unix_ms = 28;
   */
  layLowUntilUnixMs: bigint;

  /**
   * True once the player has explicitly chosen their faction via SetFaction.
   * False means the faction is still the random value assigned at registration
   * and the client must show the faction picker before completing login.
   * Self-profile only — the public projection never sets it.
   *
   * @generated from field: bool faction_chosen = 29;
   */
  factionChosen: boolean;

  /**
   * Stored (protected) dirty cash held in the player's safehouse. Capacity is
   * tier-derived (domain.SafehouseCashCapacity). Self-profile only — the public
   * projection never sets it.
   *
   * @generated from field: int64 safehouse_cash = 30;
   */
  safehouseCash: bigint;

  /**
   * Family (clan) badge. Empty / 0 when the player belongs to no family.
   *
   * Carried on the profile rather than fetched separately so the badge costs no
   * extra round trip: these are resolved by one LEFT JOIN on the existing
   * player SELECT, reading the denormalised players.family_id pointer. That
   * pointer exists for exactly this, and internal/auth never imports
   * internal/family as a result.
   *
   * NOT the faction (field 2). A faction is a permanent archetype chosen at
   * signup; a family is a player-created organisation. The two are independent.
   *
   * @generated from field: string family_id = 31;
   */
  familyId: string;

  /**
   * @generated from field: string family_name = 32;
   */
  familyName: string;

  /**
   * @generated from field: string family_tag = 33;
   */
  familyTag: string;

  /**
   * @generated from field: int32 family_crest_id = 34;
   */
  familyCrestId: number;

  /**
   * @generated from field: string family_crest_tint = 35;
   */
  familyCrestTint: string;

  /**
   * Equipped cosmetic outfit, empty when the player wears their faction's
   * default look. A stable SKU ("skin_hazmat"), never a Unity mesh name — the
   * client maps it through CosmeticAppearanceConfig and falls back to the
   * faction body for anything it does not recognise, so the server can ship a
   * new outfit before the client knows about it without anyone turning
   * invisible.
   *
   * MUST also be set by toPublicPlayerProfile, not only the self projection.
   * Omitting it there is the failure mode where a cosmetic looks perfect in
   * testing — you always see yourself — and is invisible to everyone else in
   * production.
   *
   * @generated from field: string cosmetic_skin_sku = 36;
   */
  cosmeticSkinSku: string;

  /**
   * How this player's client behaves when someone attacks them:
   * "aggressive" | "neutral" | "passive". Stored so the choice survives a
   * reinstall and follows the account across devices, and read from the login
   * profile so the client is armed before the first shot lands.
   *
   * The server stores it and NEVER enforces it. A shot fired under aggressive
   * is byte-identical to a manual one, and internal/combat does not read this
   * column. Enforcing it server-side would refuse a legitimate manual shot
   * whenever the stored value was stale, and an offline aggressive player
   * fires nothing anyway.
   *
   * The MIRROR IMAGE of cosmetic_skin_sku above: this one must NOT be set by
   * toPublicPlayerProfile. A stance tells an attacker whether their victim
   * will shoot back, so leaking it hands out target selection.
   *
   * @generated from field: string combat_stance = 37;
   */
  combatStance: string;

  /**
   * True once the player has passed the age gate and the bracket is stored.
   * False on accounts created before migration 088, and on any account that
   * somehow reached login without answering — the client shows the gate and
   * calls SetAgeVerification before completing login, exactly as it does with
   * faction_chosen.
   *
   * A BOOLEAN, NOT THE BRACKET. Other players never see this field at all
   * (self-profile only), but even to the owner "verified" is the whole answer;
   * shipping the bracket string would put an age category on the wire for no
   * caller that needs it.
   *
   * @generated from field: bool age_verified = 38;
   */
  ageVerified: boolean;
};

/**
 * Describes the message player.v1.PlayerProfile.
 * Use `create(PlayerProfileSchema)` to create a new message.
 */
export const PlayerProfileSchema: GenMessage<PlayerProfile> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 7);

/**
 * @generated from message player.v1.GoogleLoginRequest
 */
export type GoogleLoginRequest = Message<"player.v1.GoogleLoginRequest"> & {
  /**
   * @generated from field: string id_token = 1;
   */
  idToken: string;

  /**
   * optional: link to existing device account
   *
   * @generated from field: string device_id = 2;
   */
  deviceId: string;
};

/**
 * Describes the message player.v1.GoogleLoginRequest.
 * Use `create(GoogleLoginRequestSchema)` to create a new message.
 */
export const GoogleLoginRequestSchema: GenMessage<GoogleLoginRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 8);

/**
 * @generated from message player.v1.FacebookLoginRequest
 */
export type FacebookLoginRequest = Message<"player.v1.FacebookLoginRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * optional: link to existing device account
   *
   * @generated from field: string device_id = 2;
   */
  deviceId: string;
};

/**
 * Describes the message player.v1.FacebookLoginRequest.
 * Use `create(FacebookLoginRequestSchema)` to create a new message.
 */
export const FacebookLoginRequestSchema: GenMessage<FacebookLoginRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 9);

/**
 * @generated from message player.v1.EmailRegisterRequest
 */
export type EmailRegisterRequest = Message<"player.v1.EmailRegisterRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * optional: link to existing device account
   *
   * @generated from field: string device_id = 4;
   */
  deviceId: string;
};

/**
 * Describes the message player.v1.EmailRegisterRequest.
 * Use `create(EmailRegisterRequestSchema)` to create a new message.
 */
export const EmailRegisterRequestSchema: GenMessage<EmailRegisterRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 10);

/**
 * @generated from message player.v1.EmailLoginRequest
 */
export type EmailLoginRequest = Message<"player.v1.EmailLoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message player.v1.EmailLoginRequest.
 * Use `create(EmailLoginRequestSchema)` to create a new message.
 */
export const EmailLoginRequestSchema: GenMessage<EmailLoginRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 11);

/**
 * @generated from message player.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"player.v1.RefreshTokenRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message player.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 12);

/**
 * @generated from message player.v1.PlayerLogoutRequest
 */
export type PlayerLogoutRequest = Message<"player.v1.PlayerLogoutRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message player.v1.PlayerLogoutRequest.
 * Use `create(PlayerLogoutRequestSchema)` to create a new message.
 */
export const PlayerLogoutRequestSchema: GenMessage<PlayerLogoutRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 13);

/**
 * @generated from message player.v1.PlayerLogoutResponse
 */
export type PlayerLogoutResponse = Message<"player.v1.PlayerLogoutResponse"> & {
};

/**
 * Describes the message player.v1.PlayerLogoutResponse.
 * Use `create(PlayerLogoutResponseSchema)` to create a new message.
 */
export const PlayerLogoutResponseSchema: GenMessage<PlayerLogoutResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 14);

/**
 * @generated from message player.v1.AuthResponse
 */
export type AuthResponse = Message<"player.v1.AuthResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: player.v1.PlayerProfile player = 3;
   */
  player?: PlayerProfile | undefined;

  /**
   * @generated from field: bool is_new_player = 4;
   */
  isNewPlayer: boolean;
};

/**
 * Describes the message player.v1.AuthResponse.
 * Use `create(AuthResponseSchema)` to create a new message.
 */
export const AuthResponseSchema: GenMessage<AuthResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 15);

/**
 * @generated from message player.v1.LinkProviderRequest
 */
export type LinkProviderRequest = Message<"player.v1.LinkProviderRequest"> & {
  /**
   * @generated from oneof player.v1.LinkProviderRequest.credential
   */
  credential: {
    /**
     * @generated from field: string google_id_token = 1;
     */
    value: string;
    case: "googleIdToken";
  } | {
    /**
     * @generated from field: string facebook_access_token = 2;
     */
    value: string;
    case: "facebookAccessToken";
  } | {
    /**
     * @generated from field: player.v1.EmailCredential email_credential = 3;
     */
    value: EmailCredential;
    case: "emailCredential";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message player.v1.LinkProviderRequest.
 * Use `create(LinkProviderRequestSchema)` to create a new message.
 */
export const LinkProviderRequestSchema: GenMessage<LinkProviderRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 16);

/**
 * @generated from message player.v1.EmailCredential
 */
export type EmailCredential = Message<"player.v1.EmailCredential"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message player.v1.EmailCredential.
 * Use `create(EmailCredentialSchema)` to create a new message.
 */
export const EmailCredentialSchema: GenMessage<EmailCredential> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 17);

/**
 * @generated from message player.v1.LinkProviderResponse
 */
export type LinkProviderResponse = Message<"player.v1.LinkProviderResponse"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;
};

/**
 * Describes the message player.v1.LinkProviderResponse.
 * Use `create(LinkProviderResponseSchema)` to create a new message.
 */
export const LinkProviderResponseSchema: GenMessage<LinkProviderResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 18);

/**
 * @generated from message player.v1.UnlinkProviderRequest
 */
export type UnlinkProviderRequest = Message<"player.v1.UnlinkProviderRequest"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;
};

/**
 * Describes the message player.v1.UnlinkProviderRequest.
 * Use `create(UnlinkProviderRequestSchema)` to create a new message.
 */
export const UnlinkProviderRequestSchema: GenMessage<UnlinkProviderRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 19);

/**
 * @generated from message player.v1.UnlinkProviderResponse
 */
export type UnlinkProviderResponse = Message<"player.v1.UnlinkProviderResponse"> & {
};

/**
 * Describes the message player.v1.UnlinkProviderResponse.
 * Use `create(UnlinkProviderResponseSchema)` to create a new message.
 */
export const UnlinkProviderResponseSchema: GenMessage<UnlinkProviderResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 20);

/**
 * @generated from message player.v1.SendMoneyRequest
 */
export type SendMoneyRequest = Message<"player.v1.SendMoneyRequest"> & {
  /**
   * UUID of the receiver
   *
   * @generated from field: string to_player_id = 1;
   */
  toPlayerId: string;

  /**
   * dirty_cash units, must be > 0
   *
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;
};

/**
 * Describes the message player.v1.SendMoneyRequest.
 * Use `create(SendMoneyRequestSchema)` to create a new message.
 */
export const SendMoneyRequestSchema: GenMessage<SendMoneyRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 21);

/**
 * @generated from message player.v1.SendMoneyResponse
 */
export type SendMoneyResponse = Message<"player.v1.SendMoneyResponse"> & {
  /**
   * UUID of the sender's notification row
   *
   * @generated from field: string transaction_id = 1;
   */
  transactionId: string;

  /**
   * balance after the transfer (for the sender)
   *
   * @generated from field: int64 sender_dirty_cash = 2;
   */
  senderDirtyCash: bigint;

  /**
   * balance after the transfer (for the sender's UI)
   *
   * @generated from field: int64 receiver_dirty_cash = 3;
   */
  receiverDirtyCash: bigint;

  /**
   * echoed amount, in case the UI needs it
   *
   * @generated from field: int64 transferred_amount = 4;
   */
  transferredAmount: bigint;
};

/**
 * Describes the message player.v1.SendMoneyResponse.
 * Use `create(SendMoneyResponseSchema)` to create a new message.
 */
export const SendMoneyResponseSchema: GenMessage<SendMoneyResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 22);

/**
 * @generated from message player.v1.SetFactionRequest
 */
export type SetFactionRequest = Message<"player.v1.SetFactionRequest"> & {
  /**
   * canonical faction code: yakuza | italian | cartel | irish
   *
   * @generated from field: string faction = 1;
   */
  faction: string;
};

/**
 * Describes the message player.v1.SetFactionRequest.
 * Use `create(SetFactionRequestSchema)` to create a new message.
 */
export const SetFactionRequestSchema: GenMessage<SetFactionRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 23);

/**
 * @generated from message player.v1.SetFactionResponse
 */
export type SetFactionResponse = Message<"player.v1.SetFactionResponse"> & {
  /**
   * updated self profile, faction_chosen = true
   *
   * @generated from field: player.v1.PlayerProfile player = 1;
   */
  player?: PlayerProfile | undefined;
};

/**
 * Describes the message player.v1.SetFactionResponse.
 * Use `create(SetFactionResponseSchema)` to create a new message.
 */
export const SetFactionResponseSchema: GenMessage<SetFactionResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 24);

/**
 * @generated from message player.v1.SetStanceRequest
 */
export type SetStanceRequest = Message<"player.v1.SetStanceRequest"> & {
  /**
   * canonical stance code: aggressive | neutral | passive
   *
   * @generated from field: string stance = 1;
   */
  stance: string;
};

/**
 * Describes the message player.v1.SetStanceRequest.
 * Use `create(SetStanceRequestSchema)` to create a new message.
 */
export const SetStanceRequestSchema: GenMessage<SetStanceRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 25);

/**
 * @generated from message player.v1.SetStanceResponse
 */
export type SetStanceResponse = Message<"player.v1.SetStanceResponse"> & {
  /**
   * updated self profile
   *
   * @generated from field: player.v1.PlayerProfile player = 1;
   */
  player?: PlayerProfile | undefined;
};

/**
 * Describes the message player.v1.SetStanceResponse.
 * Use `create(SetStanceResponseSchema)` to create a new message.
 */
export const SetStanceResponseSchema: GenMessage<SetStanceResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 26);

/**
 * One decision, as the player made it.
 *
 * @generated from message player.v1.ConsentEvent
 */
export type ConsentEvent = Message<"player.v1.ConsentEvent"> & {
  /**
   * Must match a consent_scopes row. A value the server does not know is
   * REJECTED rather than stored: a consent row against a scope nobody reads is
   * indistinguishable from no consent at all, and silently accepting it would
   * hide a client/server mismatch until an audit.
   *
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: bool granted = 2;
   */
  granted: boolean;

  /**
   * Which version of the disclosure was on screen when they decided.
   *
   * @generated from field: int32 policy_version = 3;
   */
  policyVersion: number;

  /**
   * "onboarding" | "settings" | "consent_panel". The server also knows
   * "system_default" and "backroom", but a client may not claim either —
   * system_default records that the CLIENT disabled something for want of an
   * answer, and the database refuses to let that source carry a grant.
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * The context that makes the record defensible rather than merely present.
   * Consent collected in copy the player could not read is not informed
   * consent, so the locale is evidence, not telemetry.
   *
   * @generated from field: string ui_locale = 5;
   */
  uiLocale: string;

  /**
   * @generated from field: string app_version = 6;
   */
  appVersion: string;

  /**
   * "android" | "ios" | "editor"
   *
   * @generated from field: string platform = 7;
   */
  platform: string;

  /**
   * WHEN THE PLAYER DECIDED, not when this arrived. The two differ whenever the
   * queue drained late, and the first is the one that matters.
   *
   * @generated from field: int64 occurred_unix_ms = 8;
   */
  occurredUnixMs: bigint;
};

/**
 * Describes the message player.v1.ConsentEvent.
 * Use `create(ConsentEventSchema)` to create a new message.
 */
export const ConsentEventSchema: GenMessage<ConsentEvent> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 27);

/**
 * @generated from message player.v1.RecordConsentRequest
 */
export type RecordConsentRequest = Message<"player.v1.RecordConsentRequest"> & {
  /**
   * @generated from field: repeated player.v1.ConsentEvent events = 1;
   */
  events: ConsentEvent[];
};

/**
 * Describes the message player.v1.RecordConsentRequest.
 * Use `create(RecordConsentRequestSchema)` to create a new message.
 */
export const RecordConsentRequestSchema: GenMessage<RecordConsentRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 28);

/**
 * @generated from message player.v1.RecordConsentResponse
 */
export type RecordConsentResponse = Message<"player.v1.RecordConsentResponse"> & {
  /**
   * How many events were appended. May be fewer than sent: the server drops
   * events it cannot honour (unknown scope, a client claiming a reserved
   * source) rather than failing the whole batch, because a single bad event
   * must not strand every other decision in the queue.
   *
   * @generated from field: int32 recorded = 1;
   */
  recorded: number;
};

/**
 * Describes the message player.v1.RecordConsentResponse.
 * Use `create(RecordConsentResponseSchema)` to create a new message.
 */
export const RecordConsentResponseSchema: GenMessage<RecordConsentResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 29);

/**
 * @generated from message player.v1.GetConsentsRequest
 */
export type GetConsentsRequest = Message<"player.v1.GetConsentsRequest"> & {
};

/**
 * Describes the message player.v1.GetConsentsRequest.
 * Use `create(GetConsentsRequestSchema)` to create a new message.
 */
export const GetConsentsRequestSchema: GenMessage<GetConsentsRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 30);

/**
 * @generated from message player.v1.ConsentState
 */
export type ConsentState = Message<"player.v1.ConsentState"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: bool granted = 2;
   */
  granted: boolean;

  /**
   * @generated from field: int32 policy_version = 3;
   */
  policyVersion: number;

  /**
   * @generated from field: int64 occurred_unix_ms = 4;
   */
  occurredUnixMs: bigint;
};

/**
 * Describes the message player.v1.ConsentState.
 * Use `create(ConsentStateSchema)` to create a new message.
 */
export const ConsentStateSchema: GenMessage<ConsentState> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 31);

/**
 * @generated from message player.v1.GetConsentsResponse
 */
export type GetConsentsResponse = Message<"player.v1.GetConsentsResponse"> & {
  /**
   * One entry per scope the player has ever answered. A scope that is ABSENT
   * has never been answered and must be treated as not granted.
   *
   * @generated from field: repeated player.v1.ConsentState consents = 1;
   */
  consents: ConsentState[];
};

/**
 * Describes the message player.v1.GetConsentsResponse.
 * Use `create(GetConsentsResponseSchema)` to create a new message.
 */
export const GetConsentsResponseSchema: GenMessage<GetConsentsResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 32);

/**
 * @generated from message player.v1.SetAgeVerificationRequest
 */
export type SetAgeVerificationRequest = Message<"player.v1.SetAgeVerificationRequest"> & {
  /**
   * "16_plus" is the only value a client may send. The gate refuses under-16s
   * before an account exists, so there is no legitimate client path that
   * produces "under_16" — the server rejects it, because accepting one would
   * mean an account had been created for a child and then labelled, which is
   * the outcome the gate exists to prevent.
   *
   * @generated from field: string age_bracket = 1;
   */
  ageBracket: string;
};

/**
 * Describes the message player.v1.SetAgeVerificationRequest.
 * Use `create(SetAgeVerificationRequestSchema)` to create a new message.
 */
export const SetAgeVerificationRequestSchema: GenMessage<SetAgeVerificationRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 33);

/**
 * @generated from message player.v1.SetAgeVerificationResponse
 */
export type SetAgeVerificationResponse = Message<"player.v1.SetAgeVerificationResponse"> & {
  /**
   * @generated from field: player.v1.PlayerProfile player = 1;
   */
  player?: PlayerProfile | undefined;
};

/**
 * Describes the message player.v1.SetAgeVerificationResponse.
 * Use `create(SetAgeVerificationResponseSchema)` to create a new message.
 */
export const SetAgeVerificationResponseSchema: GenMessage<SetAgeVerificationResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 34);

/**
 * Something that survives the scrub, and the reason it does.
 *
 * LOCALIZATION KEYS, NOT SENTENCES. The client resolves these through its own
 * string tables, so the list reads in the player's language rather than in
 * whatever language the server was written in — and it is a legal disclosure,
 * which makes that the difference between informing somebody and appearing to.
 *
 * @generated from message player.v1.RetainedItem
 */
export type RetainedItem = Message<"player.v1.RetainedItem"> & {
  /**
   * e.g. "erasure_retained_purchases"
   *
   * @generated from field: string category_key = 1;
   */
  categoryKey: string;

  /**
   * e.g. "erasure_basis_tax_law"
   *
   * @generated from field: string basis_key = 2;
   */
  basisKey: string;

  /**
   * e.g. "erasure_until_tax_period"
   *
   * @generated from field: string until_key = 3;
   */
  untilKey: string;
};

/**
 * Describes the message player.v1.RetainedItem.
 * Use `create(RetainedItemSchema)` to create a new message.
 */
export const RetainedItemSchema: GenMessage<RetainedItem> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 35);

/**
 * @generated from message player.v1.RequestAccountDeletionRequest
 */
export type RequestAccountDeletionRequest = Message<"player.v1.RequestAccountDeletionRequest"> & {
  /**
   * Proof that the person holding this session is the account owner. Exactly
   * one is required: password for accounts with an email credential, otherwise
   * a freshly minted provider token. An account with neither cannot be deleted
   * from the client and must go through the operator path.
   *
   * @generated from field: string password = 1;
   */
  password: string;

  /**
   * @generated from field: string provider_token = 2;
   */
  providerToken: string;

  /**
   * The player's own nickname, typed out. The deliberate friction: it is the
   * difference between meaning it and mis-tapping a red button.
   *
   * @generated from field: string nickname_confirmation = 3;
   */
  nicknameConfirmation: string;
};

/**
 * Describes the message player.v1.RequestAccountDeletionRequest.
 * Use `create(RequestAccountDeletionRequestSchema)` to create a new message.
 */
export const RequestAccountDeletionRequestSchema: GenMessage<RequestAccountDeletionRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 36);

/**
 * @generated from message player.v1.RequestAccountDeletionResponse
 */
export type RequestAccountDeletionResponse = Message<"player.v1.RequestAccountDeletionResponse"> & {
  /**
   * @generated from field: int64 requested_unix_ms = 1;
   */
  requestedUnixMs: bigint;

  /**
   * When the worker may begin. Everything visible — push, presence, the
   * account appearing anywhere — has already stopped by the time this returns;
   * only the irreversible part waits.
   *
   * @generated from field: int64 scheduled_completion_unix_ms = 2;
   */
  scheduledCompletionUnixMs: bigint;

  /**
   * @generated from field: repeated player.v1.RetainedItem retained = 3;
   */
  retained: RetainedItem[];
};

/**
 * Describes the message player.v1.RequestAccountDeletionResponse.
 * Use `create(RequestAccountDeletionResponseSchema)` to create a new message.
 */
export const RequestAccountDeletionResponseSchema: GenMessage<RequestAccountDeletionResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 37);

/**
 * @generated from message player.v1.CancelAccountDeletionRequest
 */
export type CancelAccountDeletionRequest = Message<"player.v1.CancelAccountDeletionRequest"> & {
};

/**
 * Describes the message player.v1.CancelAccountDeletionRequest.
 * Use `create(CancelAccountDeletionRequestSchema)` to create a new message.
 */
export const CancelAccountDeletionRequestSchema: GenMessage<CancelAccountDeletionRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 38);

/**
 * @generated from message player.v1.CancelAccountDeletionResponse
 */
export type CancelAccountDeletionResponse = Message<"player.v1.CancelAccountDeletionResponse"> & {
  /**
   * @generated from field: player.v1.PlayerProfile player = 1;
   */
  player?: PlayerProfile | undefined;
};

/**
 * Describes the message player.v1.CancelAccountDeletionResponse.
 * Use `create(CancelAccountDeletionResponseSchema)` to create a new message.
 */
export const CancelAccountDeletionResponseSchema: GenMessage<CancelAccountDeletionResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 39);

/**
 * @generated from message player.v1.GetAccountDeletionStatusRequest
 */
export type GetAccountDeletionStatusRequest = Message<"player.v1.GetAccountDeletionStatusRequest"> & {
};

/**
 * Describes the message player.v1.GetAccountDeletionStatusRequest.
 * Use `create(GetAccountDeletionStatusRequestSchema)` to create a new message.
 */
export const GetAccountDeletionStatusRequestSchema: GenMessage<GetAccountDeletionStatusRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 40);

/**
 * @generated from message player.v1.GetAccountDeletionStatusResponse
 */
export type GetAccountDeletionStatusResponse = Message<"player.v1.GetAccountDeletionStatusResponse"> & {
  /**
   * "none" | "pending" | "scrubbing". Only "pending" can be cancelled.
   *
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: int64 requested_unix_ms = 2;
   */
  requestedUnixMs: bigint;

  /**
   * @generated from field: int64 scheduled_completion_unix_ms = 3;
   */
  scheduledCompletionUnixMs: bigint;

  /**
   * @generated from field: repeated player.v1.RetainedItem retained = 4;
   */
  retained: RetainedItem[];
};

/**
 * Describes the message player.v1.GetAccountDeletionStatusResponse.
 * Use `create(GetAccountDeletionStatusResponseSchema)` to create a new message.
 */
export const GetAccountDeletionStatusResponseSchema: GenMessage<GetAccountDeletionStatusResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 41);

/**
 * @generated from message player.v1.RequestDataExportRequest
 */
export type RequestDataExportRequest = Message<"player.v1.RequestDataExportRequest"> & {
  /**
   * BCP-47 tag. Chooses the language of README.txt and the rights notice in
   * metadata.json — Art. 12(1) intelligible form. The DATA keeps its English
   * field names, because Art. 20 asks for a machine-readable format and a
   * machine needs stable keys.
   *
   * @generated from field: string ui_locale = 1;
   */
  uiLocale: string;
};

/**
 * Describes the message player.v1.RequestDataExportRequest.
 * Use `create(RequestDataExportRequestSchema)` to create a new message.
 */
export const RequestDataExportRequestSchema: GenMessage<RequestDataExportRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 42);

/**
 * @generated from message player.v1.RequestDataExportResponse
 */
export type RequestDataExportResponse = Message<"player.v1.RequestDataExportResponse"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * "pending" | "building" | "ready". A repeat request returns the job already
   * running rather than an error: the player taps, nothing visible happens for
   * minutes, and they tap again. That is the ordinary case.
   *
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: int64 requested_unix_ms = 3;
   */
  requestedUnixMs: bigint;

  /**
   * Roughly how long the build takes, so the client can say something more
   * useful than "soon".
   *
   * @generated from field: int32 estimated_seconds = 4;
   */
  estimatedSeconds: number;
};

/**
 * Describes the message player.v1.RequestDataExportResponse.
 * Use `create(RequestDataExportResponseSchema)` to create a new message.
 */
export const RequestDataExportResponseSchema: GenMessage<RequestDataExportResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 43);

/**
 * @generated from message player.v1.GetDataExportRequest
 */
export type GetDataExportRequest = Message<"player.v1.GetDataExportRequest"> & {
};

/**
 * Describes the message player.v1.GetDataExportRequest.
 * Use `create(GetDataExportRequestSchema)` to create a new message.
 */
export const GetDataExportRequestSchema: GenMessage<GetDataExportRequest> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 44);

/**
 * @generated from message player.v1.GetDataExportResponse
 */
export type GetDataExportResponse = Message<"player.v1.GetDataExportResponse"> & {
  /**
   * "none" | "pending" | "building" | "ready" | "failed" | "expired".
   *
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: int64 requested_unix_ms = 2;
   */
  requestedUnixMs: bigint;

  /**
   * @generated from field: int64 completed_unix_ms = 3;
   */
  completedUnixMs: bigint;

  /**
   * Present only while state == "ready". Empty otherwise, and never stored:
   * it is minted for this response and expires in minutes.
   *
   * @generated from field: string download_url = 4;
   */
  downloadUrl: string;

  /**
   * @generated from field: int64 download_expires_unix_ms = 5;
   */
  downloadExpiresUnixMs: bigint;

  /**
   * @generated from field: int64 size_bytes = 6;
   */
  sizeBytes: bigint;

  /**
   * When the file itself stops existing. The bucket lifecycle rule enforces
   * this; the field is what lets the client say so before the link dies.
   *
   * @generated from field: int64 available_until_unix_ms = 7;
   */
  availableUntilUnixMs: bigint;
};

/**
 * Describes the message player.v1.GetDataExportResponse.
 * Use `create(GetDataExportResponseSchema)` to create a new message.
 */
export const GetDataExportResponseSchema: GenMessage<GetDataExportResponse> = /*@__PURE__*/
  messageDesc(file_player_v1_player, 45);

/**
 * @generated from service player.v1.PlayerService
 */
export const PlayerService: GenService<{
  /**
   * Existing RPCs
   *
   * @generated from rpc player.v1.PlayerService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.UpdateLocation
   */
  updateLocation: {
    methodKind: "unary";
    input: typeof UpdateLocationRequestSchema;
    output: typeof UpdateLocationResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.GetPlayer
   */
  getPlayer: {
    methodKind: "unary";
    input: typeof GetPlayerRequestSchema;
    output: typeof PlayerProfileSchema;
  },
  /**
   * Multi-provider auth RPCs
   *
   * @generated from rpc player.v1.PlayerService.LoginWithGoogle
   */
  loginWithGoogle: {
    methodKind: "unary";
    input: typeof GoogleLoginRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.LoginWithFacebook
   */
  loginWithFacebook: {
    methodKind: "unary";
    input: typeof FacebookLoginRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.RegisterWithEmail
   */
  registerWithEmail: {
    methodKind: "unary";
    input: typeof EmailRegisterRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.LoginWithEmail
   */
  loginWithEmail: {
    methodKind: "unary";
    input: typeof EmailLoginRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.PlayerLogout
   */
  playerLogout: {
    methodKind: "unary";
    input: typeof PlayerLogoutRequestSchema;
    output: typeof PlayerLogoutResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.LinkProvider
   */
  linkProvider: {
    methodKind: "unary";
    input: typeof LinkProviderRequestSchema;
    output: typeof LinkProviderResponseSchema;
  },
  /**
   * @generated from rpc player.v1.PlayerService.UnlinkProvider
   */
  unlinkProvider: {
    methodKind: "unary";
    input: typeof UnlinkProviderRequestSchema;
    output: typeof UnlinkProviderResponseSchema;
  },
  /**
   * P2P dirty-cash transfer. Sender is identified by the auth interceptor
   * via middleware.PlayerIDFromContext; only the receiver + amount are in
   * the request. Server writes two player_notifications rows (money_sent
   * for sender, money_received for receiver) inside the transfer transaction
   * and fans them out via the player:{id} Redis channel so both parties see
   * the event in realtime.
   *
   * @generated from rpc player.v1.PlayerService.SendMoney
   */
  sendMoney: {
    methodKind: "unary";
    input: typeof SendMoneyRequestSchema;
    output: typeof SendMoneyResponseSchema;
  },
  /**
   * One-time faction choice made from the client's post-login picker. The
   * caller is identified by the auth interceptor (middleware.PlayerIDFromContext);
   * only the chosen faction is in the request. Guarded server-side: allowed
   * only while the player's faction_chosen flag is false, otherwise
   * FailedPrecondition (faction_already_chosen). The response carries the
   * updated profile only — the client follows up with RefreshToken so its
   * JWT's faction claim matches the new value.
   *
   * @generated from rpc player.v1.PlayerService.SetFaction
   */
  setFaction: {
    methodKind: "unary";
    input: typeof SetFactionRequestSchema;
    output: typeof SetFactionResponseSchema;
  },
  /**
   * Combat stance. Unlike SetFaction this is NOT one-time — a player may
   * change it whenever they like, so there is no *_chosen flag, no
   * FailedPrecondition, and setting the value it already holds succeeds.
   * No RefreshToken follow-up either: stance is not a JWT claim, because no
   * server path reads it.
   *
   * @generated from rpc player.v1.PlayerService.SetStance
   */
  setStance: {
    methodKind: "unary";
    input: typeof SetStanceRequestSchema;
    output: typeof SetStanceResponseSchema;
  },
  /**
   * Append consent decisions to the immutable log (migration 087).
   *
   * BATCHED, because the client queues offline. A privacy toggle must never
   * block on the network — a player turning something OFF in a tunnel has
   * withdrawn consent at that moment, and the SDK is stopped locally at that
   * moment, whatever the radio is doing. The queue drains in one call when
   * connectivity returns, which is why every event carries its own
   * occurred_unix_ms rather than being stamped on arrival.
   *
   * The caller is identified by the auth interceptor
   * (middleware.PlayerIDFromContext); there is no player_id in the request.
   *
   * @generated from rpc player.v1.PlayerService.RecordConsent
   */
  recordConsent: {
    methodKind: "unary";
    input: typeof RecordConsentRequestSchema;
    output: typeof RecordConsentResponseSchema;
  },
  /**
   * Current consent state, one row per scope the player has ever answered.
   *
   * A scope the player has never been asked about is ABSENT from the response,
   * not present-and-false. Callers must treat absent as "not granted": under
   * Art. 4(11) consent is freely given, specific, informed and unambiguous, and
   * silence is none of those. Used on a reinstall so a player who already
   * decided is not asked again.
   *
   * @generated from rpc player.v1.PlayerService.GetConsents
   */
  getConsents: {
    methodKind: "unary";
    input: typeof GetConsentsRequestSchema;
    output: typeof GetConsentsResponseSchema;
  },
  /**
   * Records that the player passed the client-side age gate.
   *
   * Same shape as SetFaction and for the same reason: a one-time fact the
   * client must supply once after login, gated on a flag carried in the
   * profile, so GameBootstrap can defer OnLoginSuccess behind it on both the
   * auth-screen path and the silent refresh.
   *
   * THE DATE OF BIRTH IS NOT IN THIS REQUEST AND MUST NEVER BE. The client
   * computes the bracket and discards the date in the same method. Sending a
   * DOB to answer a yes/no question is the Art. 5(1)(c) failure migration 088's
   * header describes; there is also nowhere in the schema to put one.
   *
   * @generated from rpc player.v1.PlayerService.SetAgeVerification
   */
  setAgeVerification: {
    methodKind: "unary";
    input: typeof SetAgeVerificationRequestSchema;
    output: typeof SetAgeVerificationResponseSchema;
  },
  /**
   * Schedules the erasure of this account (Art. 17).
   *
   * REAUTHENTICATION IS REQUIRED, and it is not theatre: a valid access token
   * is a thing that can be lifted from an unlocked phone, and this is the one
   * RPC whose effect cannot be undone by an administrator afterwards. The
   * caller proves possession of the credential (password, or a fresh provider
   * token) AND types their own nickname, which is the step that separates
   * "I meant this" from a mis-tap.
   *
   * There is no player_id in the request. Adding one would turn this into a
   * way to schedule the deletion of somebody else's account.
   *
   * The response carries what will be KEPT and why. Article 17(3) retention is
   * lawful; retaining it silently is not, and the player sees that list before
   * they confirm as well as after.
   *
   * @generated from rpc player.v1.PlayerService.RequestAccountDeletion
   */
  requestAccountDeletion: {
    methodKind: "unary";
    input: typeof RequestAccountDeletionRequestSchema;
    output: typeof RequestAccountDeletionResponseSchema;
  },
  /**
   * Calls the erasure off during the grace period.
   *
   * Only while the request is still 'pending'. Once the worker has begun
   * scrubbing, rows are already gone and "restored" would be a lie about an
   * account that is half hollow — the server says NotFound rather than
   * pretending.
   *
   * @generated from rpc player.v1.PlayerService.CancelAccountDeletion
   */
  cancelAccountDeletion: {
    methodKind: "unary";
    input: typeof CancelAccountDeletionRequestSchema;
    output: typeof CancelAccountDeletionResponseSchema;
  },
  /**
   * What, if anything, is scheduled. Callable inside a restricted session,
   * because it is how the client knows to show the "deletion scheduled" screen
   * instead of the map.
   *
   * @generated from rpc player.v1.PlayerService.GetAccountDeletionStatus
   */
  getAccountDeletionStatus: {
    methodKind: "unary";
    input: typeof GetAccountDeletionStatusRequestSchema;
    output: typeof GetAccountDeletionStatusResponseSchema;
  },
  /**
   * --- Art. 15 / Art. 20: a copy of your data ---
   *
   * ASYNCHRONOUS, AND THAT IS NOT AN OPTIMISATION. Building a bundle reads
   * most of an account — ninety days of chat, every shot fired, the whole
   * inventory. A synchronous version overflows the gRPC-Web message limit for
   * exactly the players with the most to export, and hands anyone a cheap call
   * that makes the server read a hundred thousand rows.
   *
   * No player_id in either request, for the same reason as the deletion RPCs:
   * a player_id here would be a way to read somebody else's entire life.
   *
   * @generated from rpc player.v1.PlayerService.RequestDataExport
   */
  requestDataExport: {
    methodKind: "unary";
    input: typeof RequestDataExportRequestSchema;
    output: typeof RequestDataExportResponseSchema;
  },
  /**
   * Returns the state and, once ready, a SHORT-LIVED download link.
   *
   * The link is minted per call rather than stored, and lives for minutes. It
   * is a bearer credential to the most concentrated personal data this system
   * produces: anyone holding it needs no account and no password.
   *
   * @generated from rpc player.v1.PlayerService.GetDataExport
   */
  getDataExport: {
    methodKind: "unary";
    input: typeof GetDataExportRequestSchema;
    output: typeof GetDataExportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_player_v1_player, 0);

